import { createAction, props } from '@ngrx/store'
import { IBeneficiario, IBeneficiarioEstudio, ICreateBeneficiario, IDeleteBeneficiarioResponse, IUpdateBeneficiario, IUpdateBeneficiarioResponse, ILoadPadron, ILoadPadronResponse } from '../../interfaces/beneficiarios.interface';

export const GetBeneficiarios = createAction(
  '[Beneficiarios] Get Beneficiarios',
);

export const GetBeneficiariosSuccess = createAction(
  '[Beneficiarios] Get Beneficiarios Success',
  props<{ beneficiarios: IBeneficiario[] }>()
);

export const CreateBeneficiario = createAction(
  '[Beneficiarios] Create Beneficiario',
  props<{ beneficiario: ICreateBeneficiario }>()
);

export const CreateBeneficiarioSuccess = createAction(
  '[Beneficiarios] Create Beneficiario Success',
  props<{ beneficiario: IBeneficiario }>()
);

export const DeleteBeneficiario = createAction(
  '[Beneficiarios] Delete Beneficiario',
  props<{ id: string }>()
);

export const DeleteBeneficiarioSuccess = createAction(
  '[Beneficiarios] Delete Beneficiario Success',
  props<{ beneficiario: IDeleteBeneficiarioResponse }>()
);

export const UpdateBeneficiario = createAction(
  '[Beneficiarios] Update Beneficiario',
  props<{ id: string, beneficiario: IUpdateBeneficiario }>()
);

export const UpdateBeneficiarioSuccess = createAction(
  '[Beneficiarios] Update Beneficiario Success',
  props<{ beneficiario: IUpdateBeneficiario }>()
);

export const GetEstudioBeneficiario = createAction(
  '[Beneficiarios] Get Estudio Beneficiario',
  props<{ id: string }>()
);

export const GetEstudioBeneficiarioSuccess = createAction(
  '[Beneficiarios] Get Estudio Beneficiario Success',
  props<{ estudio: object }>()
);

export const UpdateEstudioBeneficiario = createAction(
  '[Beneficiarios] Update Estudio Beneficiario',
  props<{ id: string, estudio: IBeneficiarioEstudio }>()
);

export const UpdateEstudioBeneficiarioSuccess = createAction(
  '[Beneficiarios] Update Estudio Beneficiario Success',
  props<{ estudio: object }>()
);

export const LoadPadrones = createAction(
  '[Beneficiarios] Load Padrones',
  props<{ beneficiarios: ILoadPadron }>()
);

export const LoadPadronesSuccess = createAction(
  '[Beneficiarios] Load Padrones Success',
  props<{ beneficiarios: ILoadPadronResponse }>()
);
